import React from 'react';
import useSWR from 'swr';

import Slider from 'components/Slider';
import { useStores } from 'hooks/useStores';

import styles from './RelatedProducts.module.scss';

const RelatedProducts = ({ slug, title = 'Похожие товары' }) => {
  const { api } = useStores();
  const { data } = useSWR(
    { slug, _key: `product-related-${slug}` },
    api.newCatalog.getRelatedProductsBySlug
  );

  if (!data?.length) {
    return null;
  }

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>{title}</h2>
      <Slider products={data} />
    </section>
  );
};

export default RelatedProducts;
